import {DEFAULT_SITE, getTenantConfig} from '../../tenant.config.js';

// Vike's +data.shared.js isn't cumulative, so every page-level +data.shared.js that fetches its
// own data must call this too and spread it in, or it loses tenant data entirely.
export function resolveTenantData(pageContext) {
    const site = pageContext.site ?? DEFAULT_SITE;
    const {messages, faq, about, gtagId, favicon} = getTenantConfig(site);
    return {
        tenant: {site, messages, faq, about, gtagId, favicon},
    };
}
